import { authHeader, history } from "../_helpers";

import config from "../config";
import { message } from "antd";
export const pushNotificationService = {
  pushNotification,
};

//const baseUrl = 'https://www.criminalmis.in/api';
const baseUrl = process.env.REACT_APP_FCM_URL;
const authKey = process.env.REACT_APP_FCM_AUTH;
console.log("process access", process.env.REACT_APP_REGION_CMS);

function pushNotification(data) {
  const data1 = {
    notification: {
      title: data.title,
      body: data.body,
      icon: "ic_notification",
      imageUrl: data.image ? data.image : "",
      image: "https://foo.bar.pizza-monster.png",
      icon: "https://foo.bar.pizza-monster.png",
    },
    to: data.token,
  };

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",

      Authorization: "key=" + authKey,
    },
    body: JSON.stringify(data1),
  };
  return fetch(`${baseUrl}`, requestOptions);
}
